import { useState, type FormEvent } from "react";
import { Link } from "react-router";
import { requestPasswordReset } from "../lib/auth-client";
import { useT } from "../lib/use-t";

export function ForgotPasswordPage() {
  const t = useT();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(ev: FormEvent) {
    ev.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await requestPasswordReset(email);
      setSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : t("chrome.common.unknownError"));
    } finally {
      setSubmitting(false);
    }
  }

  if (sent) {
    return (
      <main className="min-h-screen flex items-center justify-center bg-bg px-5">
        <div className="max-w-sm space-y-4 text-center">
          <h1 className="text-2xl font-semibold tracking-tight">{t("forgotPassword.sentTitle")}</h1>
          <p className="text-sm text-[var(--ink-muted)]">
            {t("forgotPassword.sentDescription")}
          </p>
          <Link to="/login" className="text-[var(--accent)]">{t("forgotPassword.backToLoginAfterSent")}</Link>
        </div>
      </main>
    );
  }

  return (
    <main className="min-h-screen flex items-center justify-center bg-bg px-5 py-10">
      <div className="w-full max-w-sm space-y-6">
        <h1 className="text-2xl font-semibold tracking-tight text-center">{t("forgotPassword.title")}</h1>
        <p className="text-sm text-[var(--ink-muted)] text-center">
          {t("forgotPassword.description")}
        </p>
        <form onSubmit={onSubmit} className="space-y-3">
          <input type="email" required placeholder={t("forgotPassword.emailPlaceholder")} value={email} onChange={(e) => setEmail(e.target.value)} className="w-full rounded-md border border-[var(--border)] bg-[var(--panel-soft)] px-3 py-2 text-sm text-[var(--ink)]" />
          <button type="submit" disabled={submitting} className="w-full rounded-md bg-[var(--accent)] px-4 py-2 text-sm font-medium text-[var(--bg)] hover:bg-[var(--accent-hover)] disabled:opacity-60">
            {submitting ? t("forgotPassword.submitBusy") : t("forgotPassword.submit")}
          </button>
        </form>
        {error ? <p role="alert" className="rounded-md border border-[var(--fail)] bg-[var(--fail)]/10 px-3 py-2 text-sm text-[var(--fail)]">{error}</p> : null}
        <Link to="/login" className="block text-center text-sm text-[var(--ink-muted)]">{t("forgotPassword.backToLogin")}</Link>
      </div>
    </main>
  );
}
